/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const bandage_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6.964 13.546-4.601-4.6a4.655 4.655 0 0 1 6.582-6.583l4.601 4.601m-6.582 6.582 6.582-6.582m-6.582 6.582 3.48 3.48m3.102-10.062 3.48 3.48m0 0 4.576 4.577a4.654 4.654 0 1 1-6.581 6.581l-4.578-4.577m6.582-6.582-6.582 6.582M4.823 6.501h.346m3.654.505h.347m6.66 10.501h.345m3.655.505h.346M5.248 6.501c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm4 .505c0 .183-.16.243-.247.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm7.007 10.501c0 .183-.16.243-.249.243-.091 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm4 .505c0 .184-.16.244-.248.244-.092 0-.252-.06-.252-.244 0-.196.16-.256.252-.256.088 0 .248.06.248.256Z"
    />
  </svg>
)
export default bandage_medium
